import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=0e1ef42b"
import script from "./channel.vue?vue&type=script&lang=ts"
export * from "./channel.vue?vue&type=script&lang=ts"
import style0 from "./channel.vue?vue&type=style&index=0&id=0e1ef42b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports